/* ============================================
   Stock PDP refresh: stock silicone per-colour minimum.
   Loaded (defer) by sections/template-product.liquid only when the section's
   "Stock PDP refresh layout" checkbox is on. Ported from WristCo
   (assets/pdp-stock-refresh.js) and adapted to WRW.

   Runs only when snippets/form-product.liquid rendered [data-pdp-moq-note]:
   stock silicone (type silicone/Silicone, not tagged custom-bands/custom) with
   custom.minimum_order_quantity above 1. The minimum is read from its data-min,
   so every number below follows the product's metafield.

   custom-js-product.js and component-product-form.js are untouched. Their
   handlers run first (they sit on the inputs, +/- spans and form); this script
   listens on the form / document and corrects the result:
   - "+" from 0 to min-1 (typed or not) -> min, SUCCESS bubble. The value before
     the click is recorded in the capture phase. Skipped when the variant's stock
     (max) is between 1 and min-1.
   - "-" from 1 to min -> 0, no bubble. Above min, +/- keep today's +/-1.
   - Typed 1 to min-1: ERROR bubble on change (commit / blur), value kept. No
     bubble when the blur comes from pressing that input's own +/-.
   - Every corrected value is written with input + change events, so
     checkQuantityBox, totals, .pieces-total and WSAIO see a normal edit.
   - Native validation bubble from checkQuantityBox's reportValidity() is
     suppressed (preventDefault on "invalid"); setCustomValidity still blocks a
     native submit.
   - Ready state (order box Add to Cart): ready only when at least one colour is
     >= min and none is 1 to min-1. Not ready: label "Choose Band Colors" and
     aria-disabled (not disabled, so the click still runs). A click while a
     colour is short is cancelled and goes to the first short colour (opening its
     tab if needed): scroll (instant under reduced motion), focus, ERROR bubble.
     With every colour at 0 the click goes through to today's "select at least
     one variant" notification.
   - Submit guard (Enter key, other scripts): a submit while a colour is short is
     stopped before component-product-form.js adds anything to the cart.
   - Order-box helper under Add to Cart: error icon + copy from data-error-text
     while any colour is short; aria-live="polite".
   One bubble (appended to body) is reused for both states: one at a time,
   auto-dismiss (3s success / 4s error), Esc or outside click closes it.
   ============================================ */
(function () {
  var note = document.querySelector('.pdp-stock-refresh [data-pdp-moq-note]');
  if (!note) return;
  var form = note.closest('form');
  var noteText = note.querySelector('.pdp-moq-note__text');
  var min = parseInt(note.getAttribute('data-min'), 10) || 0;
  if (!form || !noteText || min < 2) return;
  var noteDefault = noteText.textContent;
  var noteError = noteText.getAttribute('data-error-text') || noteDefault;
  var inputs = form.querySelectorAll('[data-qty-input]');
  var atc = form.querySelector('.product-total-box [data-addtocart]');
  var atcLabel = atc && atc.querySelector('.add-text_change');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  var COPY = {
    success: 'Minimum is ' + min + ' per color.',
    error: 'Minimum is ' + min + ' per color. Please enter ' + min + ' or more.'
  };
  var LABEL = { ready: 'Add to Cart', notReady: 'Choose Band Colors' };
  var ICONS = {
    success: '<svg width="16" height="16" viewBox="0 0 16 16" focusable="false"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M4.75 8.25 7 10.5l4.25-4.75" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    error: '<svg width="16" height="16" viewBox="0 0 16 16" focusable="false"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M8 4.25v4.5" stroke="#fff" stroke-width="1.6" stroke-linecap="round"/><circle cx="8" cy="11.4" r="1" fill="#fff"/></svg>'
  };
  var DURATION = { success: 3000, error: 4000 };

  var bubble = document.createElement('div');
  bubble.id = 'pdp-qty-bubble';
  bubble.className = 'pdp-qty-bubble';
  bubble.hidden = true;
  bubble.innerHTML = '<span class="pdp-qty-bubble__icon" aria-hidden="true"></span><span class="pdp-qty-bubble__text"></span>';
  document.body.appendChild(bubble);
  var bubbleIcon = bubble.querySelector('.pdp-qty-bubble__icon');
  var bubbleText = bubble.querySelector('.pdp-qty-bubble__text');

  var current = null; // { input, wrapper, state, describedBy }
  var dismissTimer = null;
  var hideTimer = null;
  var preClick = null; // { input, value } before the +/- handlers run
  var stepping = null; // input whose +/- is being pressed
  var steppingTimer = null;

  function wrapperOf(input) {
    return input.closest('.quantity-wrapper') || input;
  }

  function inputOf(button) {
    var wrapper = button.closest('.quantity-wrapper');
    return wrapper && wrapper.querySelector('[data-qty-input]');
  }

  function valueOf(input) {
    return parseInt(input.value, 10) || 0;
  }

  function isShort(value) {
    return value > 0 && value < min;
  }

  // Same guard as custom-js-product.js handleIncrease / handleDecrease.
  function isOutOfStock(input) {
    var swatch = input.closest('.swatch');
    var radio = swatch && swatch.querySelector('.variant-radio');
    return !!(radio && radio.classList.contains('out-stock'));
  }

  function hideBubble() {
    clearTimeout(dismissTimer);
    if (current) {
      current.wrapper.classList.remove('is-min-snapped');
      if (current.describedBy) {
        current.input.setAttribute('aria-describedby', current.describedBy);
      } else {
        current.input.removeAttribute('aria-describedby');
      }
      current = null;
    }
    bubble.classList.remove('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      if (current) return;
      bubble.hidden = true;
      bubbleText.textContent = '';
    }, 150);
  }

  // Centred under the input's box, clamped 8px inside the viewport; the
  // pointer follows the input centre (--pdp-bubble-arrow).
  function placeBubble() {
    if (!current) return;
    var rect = current.wrapper.getBoundingClientRect();
    var width = bubble.offsetWidth;
    var centre = rect.left + rect.width / 2;
    var left = Math.max(8, Math.min(centre - width / 2, document.documentElement.clientWidth - width - 8));
    bubble.style.left = left + window.pageXOffset + 'px';
    bubble.style.top = rect.bottom + window.pageYOffset + 10 + 'px';
    bubble.style.setProperty('--pdp-bubble-arrow', centre - left + 'px');
  }

  function showBubble(input, state) {
    hideBubble();
    clearTimeout(hideTimer);
    var wrapper = wrapperOf(input);
    current = { input: input, wrapper: wrapper, state: state, describedBy: input.getAttribute('aria-describedby') };
    if (state === 'success') wrapper.classList.add('is-min-snapped');
    input.setAttribute('aria-describedby', (current.describedBy ? current.describedBy + ' ' : '') + bubble.id);

    // Live-region attributes go on before the text, so the text is announced.
    bubble.className = 'pdp-qty-bubble pdp-qty-bubble--' + state;
    bubble.setAttribute('role', state === 'error' ? 'alert' : 'status');
    bubble.setAttribute('aria-live', state === 'error' ? 'assertive' : 'polite');
    bubbleIcon.innerHTML = ICONS[state];
    bubbleText.textContent = '';
    bubble.hidden = false;

    var shown = current;
    setTimeout(function () {
      if (current !== shown) return;
      bubbleText.textContent = COPY[state];
      placeBubble();
      bubble.classList.add('is-visible');
      dismissTimer = setTimeout(hideBubble, DURATION[state]);
    }, 30);
  }

  // Outlines, aria-invalid, helper line and Add to Cart state. markNew false
  // (while typing): only clears inputs that are no longer short, so a half-typed
  // value doesn't turn red before change / blur. Returns the short inputs.
  function update(markNew) {
    var short = [];
    var met = false;
    inputs.forEach(function (input) {
      var value = valueOf(input);
      var wrapper = wrapperOf(input);
      if (isShort(value)) {
        short.push(input);
        if (markNew !== false) {
          wrapper.classList.add('is-below-min');
          input.setAttribute('aria-invalid', 'true');
        }
      } else {
        if (value >= min) met = true;
        wrapper.classList.remove('is-below-min');
        input.removeAttribute('aria-invalid');
      }
    });

    if (markNew !== false || !short.length) {
      note.classList.toggle('is-below-min', short.length > 0);
      var text = short.length ? noteError : noteDefault;
      if (noteText.textContent !== text) noteText.textContent = text;
    }

    // updateVariantTotals (custom-js-product.js) labels on the combined total
    // only; this runs after it on the same event and applies the per-colour rule.
    var ready = met && !short.length;
    if (atc) {
      if (ready) {
        atc.removeAttribute('aria-disabled');
      } else {
        atc.setAttribute('aria-disabled', 'true');
      }
      if (atcLabel) {
        var label = ready ? LABEL.ready : LABEL.notReady;
        if (atcLabel.textContent.trim() !== label) atcLabel.textContent = label;
      }
    }

    // Error bubble closes once its value is fixed.
    if (current && current.state === 'error' && !isShort(valueOf(current.input))) hideBubble();
    return short;
  }

  // Same events typing fires, so custom-js-product.js's input / change
  // listeners (checkQuantityBox) and any app listeners recalculate.
  function setQty(input, value) {
    input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // First short colour: open its tab if it is hidden, scroll to it, focus it
  // and show the ERROR bubble. Still hidden (no tab found): the helper line
  // already says to check the highlighted colours.
  function goToShort(input) {
    var delay = 0;
    if (input.offsetParent === null) {
      var pane = input.closest('.tab-pane');
      var link = pane && pane.id && document.querySelector('.tablink a[data-tabcontent="#' + pane.id + '"]');
      if (link) {
        link.closest('.tablink').click();
        delay = 150;
      }
    }
    setTimeout(function () {
      if (input.offsetParent === null) return;
      var smooth = !reducedMotion.matches;
      wrapperOf(input).scrollIntoView({ block: 'center', behavior: smooth ? 'smooth' : 'auto' });
      input.focus({ preventScroll: true });
      // After the scroll so the bubble is placed against the input's new position.
      setTimeout(function () { showBubble(input, 'error'); }, smooth ? 350 : 0);
    }, delay);
  }

  // Pressing +/-: blurring the input fires change before the click; don't
  // show the ERROR bubble for that change, the click decides.
  form.addEventListener('pointerdown', function (event) {
    var button = event.target.closest && event.target.closest('.qty-btn');
    var input = button && inputOf(button);
    if (!input) return;
    stepping = input;
    clearTimeout(steppingTimer);
    steppingTimer = setTimeout(function () { stepping = null; }, 1000);
  }, true);

  // Capture: before custom-js-product.js's +/- handlers change the value.
  form.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.qty-btn');
    var input = button && inputOf(button);
    preClick = input ? { input: input, value: valueOf(input) } : null;
  }, true);

  form.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.qty-btn');
    if (!button) return;
    var input = inputOf(button);
    var before = preClick && preClick.input === input ? preClick.value : null;
    preClick = null;
    stepping = null;
    clearTimeout(steppingTimer);
    if (!input || input.disabled || isOutOfStock(input) || before === null) {
      update();
      return;
    }
    var max = parseInt(input.getAttribute('max'), 10);
    if (button.classList.contains('qty-increase')) {
      if (before < min && !(max > 0 && max < min)) {
        if (valueOf(input) !== min) setQty(input, min);
        showBubble(input, 'success');
      }
    } else if (before > 0 && before <= min && valueOf(input) !== 0) {
      setQty(input, 0);
    }
    update();
  });

  form.addEventListener('input', function () {
    update(false);
  });

  form.addEventListener('change', function (event) {
    update();
    var input = event.target;
    if (!event.isTrusted || !input.matches || !input.matches('[data-qty-input]')) return;
    if (stepping === input) return;
    if (isShort(valueOf(input))) showBubble(input, 'error');
  });

  // reportValidity() in checkQuantityBox and native submit validation both fire
  // "invalid" (doesn't bubble: capture). Cancelling it hides the native bubble
  // only; the custom validity stays and still blocks a native submit.
  form.addEventListener('invalid', function (event) {
    var input = event.target;
    if (input.matches && input.matches('[data-qty-input]') && input.validity.customError) event.preventDefault();
  }, true);

  // Add to Cart while a colour is short (Enter in a quantity box clicks it too).
  // Document capture: before the button's own default (submit) runs.
  if (atc) {
    document.addEventListener('click', function (event) {
      if (!atc.contains(event.target)) return;
      var short = update();
      if (!short.length) return;
      event.preventDefault();
      goToShort(short[0]);
    }, true);
  }

  // Any other submit path. Document capture runs before
  // component-product-form.js's submit listener on the form.
  document.addEventListener('submit', function (event) {
    if (event.target !== form) return;
    var short = update();
    if (!short.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    goToShort(short[0]);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && current) hideBubble();
  });
  document.addEventListener('pointerdown', function (event) {
    if (current && !bubble.contains(event.target)) hideBubble();
  });
  // Re-place rather than close: the mobile keyboard opening after the focus
  // above resizes the window.
  window.addEventListener('resize', placeBubble);

  update();
})();

/* ============================================
   Order box ready state, stock products without the per-colour minimum
   (no [data-pdp-moq-note]; the block above owns aria-disabled there).
   custom-js-product.js only swaps the label at qty 0 ("Choose Band Colors"),
   so this mirrors it as aria-disabled for the CSS ready / not-ready states.
   Same signal as the sticky bar: .pieces-total.
   ============================================ */
(function () {
  var section = document.querySelector('.pdp-stock-refresh');
  if (!section || section.querySelector('[data-pdp-moq-note]')) return;
  var atc = section.querySelector('.product-total-box [data-addtocart]');
  var piecesTotal = section.querySelector('.pieces-total');
  if (!atc || !piecesTotal) return;

  function sync() {
    if ((parseInt(piecesTotal.textContent, 10) || 0) === 0) {
      atc.setAttribute('aria-disabled', 'true');
    } else {
      atc.removeAttribute('aria-disabled');
    }
  }

  new MutationObserver(sync).observe(piecesTotal, { childList: true, characterData: true, subtree: true });
  sync();
})();

/* ============================================
   Stock PDP refresh: sticky Add To Cart bar ([data-stock-stickybar]), all stock
   products on the refresh, mobile and desktop.
   The bar is rendered by layout/theme.liquid (non-silicone) or
   snippets/stock-stickybar.liquid (stock silicone, from template-product.liquid);
   both are the same markup. Existing behaviour is kept as-is:
   - template-product.js: .active while the order box is out of view
     (IntersectionObserver on .product-total-box).
   - custom-js-product.js: .has-qty once the total is 1 or more, body.has-sticky-atc,
     click proxied to the real Add to Cart (so the per-colour minimum guard above
     applies to the bar too), disabled / loading mirrored.
   This block adds, without touching those files:
   - .is-pdp-refresh (assets/pdp-stock-refresh.css D11) and drops the bar's
     .bg-secondary / .text-white utilities (both !important) for the white look.
   - Its own quantity + total elements, mirrored from the order box. The bar never
     uses .pieces-total / .total-price, so WSAIO only ever sees the order box's.
     Total = whichever of .wspoduct-price (WSAIO) / .total-price is shown, so
     wholesale prices reach the bar. The old .sticky-total line stays in the DOM
     (custom-js-product.js writes it) but is hidden.
   - The real button's label and aria-disabled, so the bar shares its ready state.
     At qty 0 (desktop shows the bar then): "Choose Band Colors" + aria-disabled,
     and a click scrolls to and focuses the first colour's quantity box, no bubble.
   - Mobile still waits for .has-qty; desktop shows on .active alone (CSS D11).
   - Desktop: --pdp-sticky-left / --pdp-sticky-width from the right column's
     content box, so the bar lines up with the order box (ported from WristCo).
   ============================================ */
(function () {
  var section = document.querySelector('.pdp-stock-refresh');
  var bar = document.querySelector('[data-stock-stickybar]');
  if (!section || !bar) return;
  if (document.querySelectorAll('.product-stickybar').length > 1) {
    console.warn('pdp-stock-refresh: more than one .product-stickybar on the page; only the first is wired up.');
  }
  var box = section.querySelector('.product-total-box');
  var main = box && box.querySelector('[data-addtocart]');
  var mainLabel = main && main.querySelector('.add-text_change');
  var button = bar.querySelector('[data-sticky-addtocart]');
  var buttonLabel = button && button.querySelector('.add-text');
  var oldLine = bar.querySelector('.sticky-total');
  oldLine = oldLine && oldLine.closest('p');
  var piecesTotal = box && box.querySelector('.pieces-total');
  var totalPrice = box && box.querySelector('.total-price');
  var wsPrice = box && box.querySelector('.wspoduct-price');
  if (!box || !main || !button || !oldLine || !piecesTotal || !totalPrice) return;

  // Label text from the order box itself ("Total Packs:" / "Total Pieces:",
  // "Total Price:"), so the bar always reads the same as the box.
  function labelOf(valueEl) {
    var row = valueEl.parentElement;
    var label = row && row.querySelector('p');
    return label ? label.textContent.replace(/\s+/g, ' ').replace(/\s*:\s*$/, '').trim() + ':' : '';
  }

  bar.classList.remove('bg-secondary', 'text-white');
  bar.classList.add('is-pdp-refresh');
  oldLine.hidden = true;

  var info = document.createElement('div');
  info.className = 'pdp-bar-info';
  info.innerHTML =
    '<p class="pdp-bar-line"><span class="pdp-bar-label"></span> <span class="pdp-bar-qty"></span></p>' +
    '<p class="pdp-bar-line"><span class="pdp-bar-label"></span> <span class="pdp-bar-total"></span></p>';
  oldLine.parentNode.insertBefore(info, oldLine);
  var labels = info.querySelectorAll('.pdp-bar-label');
  labels[0].textContent = labelOf(piecesTotal);
  labels[1].textContent = labelOf(totalPrice);
  var qtyOut = info.querySelector('.pdp-bar-qty');
  var totalOut = info.querySelector('.pdp-bar-total');

  var EMPTY_LABEL = 'Choose Band Colors';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isShown(el) {
    return !!el && el.getClientRects().length > 0 && el.textContent.trim() !== '';
  }

  function isEmpty() {
    return (parseInt(piecesTotal.textContent, 10) || 0) === 0;
  }

  // Bar click at qty 0: go to the first colour's quantity box instead of the
  // real button's "select at least one variant" notification. Document capture,
  // so custom-js-product.js's proxy on the bar button never runs for it. With a
  // quantity the proxy runs as before (and the minimum guard above with it).
  document.addEventListener('click', function (event) {
    if (!button.contains(event.target) || !isEmpty()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var first = Array.prototype.find.call((box.closest('form') || document).querySelectorAll('[data-qty-input]'), function (input) {
      return !input.disabled && input.offsetParent !== null;
    });
    if (!first) return;
    var wrapper = first.closest('.quantity-wrapper') || first;
    wrapper.scrollIntoView({ block: 'center', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    first.focus({ preventScroll: true });
  }, true);

  function sync() {
    var qty = piecesTotal.textContent.trim();
    if (qtyOut.textContent !== qty) qtyOut.textContent = qty;
    var total = (isShown(wsPrice) ? wsPrice : totalPrice).textContent.trim();
    if (totalOut.textContent !== total) totalOut.textContent = total;

    // Qty 0 (desktop shows the bar before any quantity): not ready, whatever the
    // real button's Liquid label still says. Otherwise mirror the real button.
    var empty = isEmpty();
    if (buttonLabel) {
      var label = empty ? EMPTY_LABEL : (mainLabel ? mainLabel.textContent.trim() : '');
      if (label && buttonLabel.textContent !== label) buttonLabel.textContent = label;
    }
    if (empty || main.getAttribute('aria-disabled') === 'true') {
      button.setAttribute('aria-disabled', 'true');
    } else {
      button.removeAttribute('aria-disabled');
    }
  }

  // One sync per frame for any change in the order box (custom-js-product.js
  // totals, WSAIO price, the minimum script's label / aria-disabled).
  var queued = false;
  function queueSync() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      sync();
    });
  }
  new MutationObserver(queueSync).observe(box, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'aria-disabled']
  });
  sync();

  // Desktop alignment (WristCo pdp-stock-refresh.js): the right column's content
  // box, written as --pdp-sticky-left / --pdp-sticky-width for the CSS. Column
  // size changes come through the observer; above the container max-width the
  // column only moves sideways, which the resize listener catches.
  var column = section.querySelector('.pdp-grid-info');
  if (!column) return;
  function align() {
    var rect = column.getBoundingClientRect();
    var style = window.getComputedStyle(column);
    var paddingLeft = parseFloat(style.paddingLeft) || 0;
    var paddingRight = parseFloat(style.paddingRight) || 0;
    bar.style.setProperty('--pdp-sticky-left', rect.left + paddingLeft + 'px');
    bar.style.setProperty('--pdp-sticky-width', rect.width - paddingLeft - paddingRight + 'px');
  }
  if ('ResizeObserver' in window) {
    new ResizeObserver(align).observe(column);
  }
  window.addEventListener('resize', align);
  align();
})();
